import { Modal } from 'antd';
import type { CSSProperties, ReactNode } from 'react';
import {
  SLA_MODAL_BODY_MAX_HEIGHT,
  SLA_MODAL_SHELL_MAX_HEIGHT,
  SLA_MODAL_VIEWPORT_MAX_WIDTH,
} from '@/app/landing/sla/shared/sla.constants';

type Props = {
  open: boolean;
  title: ReactNode;
  width: string | number;
  onClose: () => void;
  headerExtra?: ReactNode;
  footer: ReactNode;
  children: ReactNode;
  pinFooter?: boolean;
  shellMaxHeight?: string;
  scrollBody?: boolean;
  maxBodyHeight?: string;
};

export function SlaModalShell({
  open,
  title,
  width,
  onClose,
  headerExtra,
  footer,
  children,
  pinFooter = false,
  shellMaxHeight,
  scrollBody = false,
  maxBodyHeight,
}: Props) {
  const resolvedShellMaxHeight = shellMaxHeight ?? SLA_MODAL_SHELL_MAX_HEIGHT;
  const cappedBodyHeight = maxBodyHeight ?? SLA_MODAL_BODY_MAX_HEIGHT;

  const bodyStyle: CSSProperties = pinFooter
    ? {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingTop: '0.75rem',
      }
    : scrollBody
      ? {
          maxHeight: cappedBodyHeight,
          overflowY: 'auto',
          paddingTop: '0.75rem',
        }
      : {
          paddingTop: '0.75rem',
        };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      width={width}
      destroyOnClose
      centered
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
          }}
        >
          {footer}
        </div>
      }
      styles={{
        container: {
          maxWidth: SLA_MODAL_VIEWPORT_MAX_WIDTH,
          ...(pinFooter
            ? {
                maxHeight: resolvedShellMaxHeight,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }
            : {}),
        },
        body: bodyStyle,
        footer: {
          flexShrink: 0,
          marginTop: 0,
        },
      }}
    >
      {headerExtra}
      {children}
    </Modal>
  );
}
